import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'
import {
  Breadcrumb,
  Button,
  Col,
  ControlLabel,
  DropdownButton,
  Form,
  FormControl,
  FormGroup,
  InputGroup,
  MenuItem,
  Modal
} from 'react-bootstrap'
import { Editor } from 'react-draft-wysiwyg'
import { convertFromRaw, convertToRaw, EditorState, ContentState, convertFromHTML } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['activities', 'partners', 'globals'])

export default class PartnerNotes extends Component {
  constructor(props) {
    super(props)

    let partnerId = this.props.partnerId
    let showEditNoteModal = false;

    this.props.partners.loadPartnerNotes(partnerId, localStorage.getItem('userHash'))

    if (this.props.noteId > 0) {
      showEditNoteModal = true
      this.openEditNoteModal(this.props.noteId)
    }

    this.state = {
      editModalTitle: 'Edit Notes',
      notes: '',
      showDetailsModal: false,
      showNewNoteModal: false,
      newNote: '',
      editorContent: null,
      showEditNoteModal
    }
  }

  save(e) {
    this.props.partners.updatePartnerNote({
      id: document.getElementById('partnerId').value,
      note: document.getElementById('editNote').value,
      hash: localStorage.getItem('userHash')
    })

    this.close()
  }

  open(e, id) {
    console.log(e)

    this.props.partners.loadPartnerNote(id, localStorage.getItem('userHash'), (data) => {
      document.getElementById('noteId').value = data.id
      document.getElementById('editNote').value = data.note
    })

    this.setState({
      showDetailsModal: true
    })
  }

  close() {
    this.setState({
      showDetailsModal: false
    })
  }

  openNewNoteModal() {
    /*
    const blocksFromHtml = convertFromHTML('')
    const state = ContentState.createFromBlockArray(
      blocksFromHtml.contentBlocks,
      blocksFromHtml.entityMap
    )
    const editorState = EditorState.createWithContent(state)

    this.setState({
      editorState: editorState
    })
    */


    this.setState({
      showNewNoteModal: true,
      editorState: ''
    })
  }

  closeNewNoteModal() {
    this.setState({
      showNewNoteModal: false
    })
  }

  openEditNoteModal(id) {
    this.props.partners.loadPartnerNote(id, (data) => {

      try {
        const note = JSON.parse(data.note)

        this.setState({
          editNoteId: id,
          editNoteContentState: note
        })
      } catch (e) {
        const blocksFromHtml = convertFromHTML(data.note)
        const state = ContentState.createFromBlockArray(
          blocksFromHtml.contentBlocks,
          blocksFromHtml.entityMap
        )
        const editorState = EditorState.createWithContent(state)

        this.setState({
          editNoteId: id,
          editNoteEditorState: editorState
        })
      }
    })

    this.setState({
      showEditNoteModal: true
    })
  }

  closeEditNoteModal() {
    this.setState({
      showEditNoteModal: false
    })
  }

  newNoteValidationState() {
    if (this.state.newNote) {
      return 'success'
    } else {
      return 'error'
    }
  }

  cleanNoteToJSON(note) {
    console.log('RAW')
    console.log(note)

    const clean = note
      .replace(/\\n/g, '\\\\n')
      .replace(/\\r/g, '\\\\r')
      .replace(/"/g, '\\"')
      .replace(/\t/g, "   ")

      //      .replace(/'/g, "\\'")


    console.log('CLEAN')
    console.log(clean)

    return clean
  }

  newPartnerNote(row) {
    const cleanNote = this.cleanNoteToJSON(JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())))

    this.props.partners.addPartnerNote({
      note: cleanNote,
      partnerId: this.props.partnerId,
      userId: this.props.globals.loggedInUser.id,
      hash: localStorage.getItem('userHash')
    }, (data) => {

      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 10, data.addPartnerNote.id, 2, data.addPartnerNote.partnerId)

      this.props.partners.loadPartnerNotes(this.props.partnerId)
    })

    this.closeNewNoteModal()
  }

  editPartnerNote() {
    let cleanNote = this.cleanNoteToJSON(JSON.stringify(convertToRaw(this.state.editNoteEditorState.getCurrentContent())))

    this.props.partners.updatePartnerNote({
      id: this.state.editNoteId,
      note: cleanNote
    }, (data) => {
      this.props.partners.loadPartnerNotes(this.props.partnerId)

      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 10, this.state.editNoteId, 2, this.props.partnerId)
    })

    this.closeEditNoteModal()
  }

  onNoteChanged(state) {
    this.setState({
      editorState: state
    })
  }

  onEditNoteChanged(state) {
    this.setState({
      editNoteEditorState: state
    })
  }

  updateNote(row, cell) {
    this.props.companies.updateNote({
      id: row.id,
      note: row.note,
      hash: localStorage.getItem('userHash')
    })
  }

  deletePartnerNote(id) {
    if (confirm("Are you sure you want to delete this note?")) {
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 10, id, 2, this.props.partnerId)

      this.props.partners.deletePartnerNote(id, this.props.partnerId, localStorage.getItem('userHash'))
    }
  }

  formatNote(cell, row) {

    let note = '';

    try {
      note = draftToHtml(JSON.parse(cell))
    } catch(e) {
      console.log('Could not parse note JSON')
      note = cell
    }

    return note
  }

  formatActions(cell, row) {
    return (<div>
      <Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEditNoteModal(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button>
      <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deletePartnerNote(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
    </div>)
  }

  sortByCreatedDate(a, b, order) {
    const aa = a.formattedCreatedDate.split('-')
    const bb = b.formattedCreatedDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDueDate(a, b, order) {
    const aa = a.formattedDueDate.split('-')
    const bb = b.formattedDueDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDate(aa, bb, order) {
    const fa = aa[2] + aa[0] + aa[1]
    const fb = bb[2] + bb[0] + bb[1]

    if (order == 'desc') {
      return fb - fa
    } else {
      return fa - fb
    }
  }

  render() {

    const options = {
      defaultSortName: 'id',  // default sort column name
      defaultSortOrder: 'desc'  // default sort order
    }

    const notesTable = (
      <div>
        <Button bsStyle="info" onClick={this.openNewNoteModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
            data={ this.props.partners.notes }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
            bordered={ false }
            >
          <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="formattedCreatedDate" sortFunc={ this.sortByCreatedDate.bind(this) } dataSort={ true } editable={ false }>Created Date</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="note" dataFormat={ this.formatNote.bind(this) } dataSort={ true }>Note</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="userFullName" editable={ false } hiddenOnInsert={ true } dataSort={ true }>Created By</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <div>
          { /* <Collapsible title="Notes" content={ notesTable } /> */ }
          { notesTable }
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showNewNoteModal } onHide={ this.closeNewNoteModal.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>New Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newNoteForm">
              <FormGroup>
                <Col sm={ 6 }>
                  <Editor toolbarHidden editorState={ this.state.editorState } onEditorStateChange={ this.onNoteChanged.bind(this) } wrapperStyle={{ border: '1px solid #ccc', height: '300px', width: '550px' }} />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeNewNoteModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.newPartnerNote.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEditNoteModal } onHide={ this.closeEditNoteModal.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>Edit Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editNoteForm">
              <FormGroup>
                <Col sm={ 6 }>
                  <Editor toolbarHidden contentState={ this.state.editNoteContentState } editorState={ this.state.editNoteEditorState } onEditorStateChange={ this.onEditNoteChanged.bind(this) } wrapperStyle={{ border: '1px solid #ccc', height: '300px', width: '550px' }} />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEditNoteModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.editPartnerNote.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        { /*
        <Modal show={ this.state.showDetailsModal } onHide={ this.close.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>{ this.state.editModalTitle }</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newPartnerForm">
              <FormGroup>
                <Col componentClass={ ControlLabel } sm={ 2 }>Notes:</Col>
                <input type="hidden" id="noteId" />
                <Col sm={ 8 }><FormControl componentClass="textarea" id="editNote" /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ () => { this.close() } }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ (e) => { this.save(e) } }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        */ }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partner/partnernotes.js